import App from "@/App";
import { AuthProvider } from "@/contexts/AuthContext";
import { TimezoneProvider } from "@/contexts/TimezoneContext";
import { initTheme } from "@/lib/theme";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "pretendard/dist/web/variable/pretendardvariable-dynamic-subset.css";
// 인쇄 전용 정적 Pretendard - 변수 폰트는 인쇄 시 weight 축이 무시돼 굵게가 사라짐
// (globals.css @media print 에서 --font-* 를 이 정적 패밀리로 재매핑).
import "pretendard/dist/web/static/pretendard-dynamic-subset.css";
import "@/styles/globals.css";

// Apply the persisted theme before the first paint to avoid a flash.
initTheme();

const root = document.getElementById("root");
if (!root) throw new Error("Root element #root not found");

createRoot(root).render(
  <StrictMode>
    <AuthProvider>
      <TimezoneProvider>
        <App />
      </TimezoneProvider>
    </AuthProvider>
  </StrictMode>
);
